export const SELECT_COURSE = 'SELECT_COURSE';